/* eslint-disable prettier/prettier */
import { useCallback, useSyncExternalStore } from 'react';
import { useMIContext } from './MIContext';
import type { MIRowState, MIStore } from './MIStore';

export const useMIRowState = (key: string): MIRowState => {
  const { store } = useMIContext();
  const subscribe = useCallback(
    (cb: () => void) => store.subscribeKey(key, cb),
    [store, key],
  );
  const getSnapshot = useCallback(() => store.getRowState(key), [store, key]);
  return useSyncExternalStore(subscribe, getSnapshot);
};

// Use when multiple row states are needed (e.g. inside a .map()).
// Re-renders whenever any row in the store changes, then callers
// read individual row states via store.getRowState(key).
export const useMIStore = (): MIStore => {
  const { store } = useMIContext();
  const subscribe = useCallback((cb: () => void) => store.subscribeAll(cb), [store]);
  const getSnapshot = useCallback(() => store.getVersion(), [store]);
  useSyncExternalStore(subscribe, getSnapshot);
  return store;
};
